export default __webpack_public_path__ + "static/media/TheScarf_05.6047dcec.png";